
import { defineComponent, ref } from "vue";
import router from "@/router";
import Loading from "@/components/Loading.vue";
import Auth from "@/controller/auth";

const ERROR_EMPTY = "Vui lòng điền đầy đủ thông tin.";
const ERROR_WRONG_CREDENTIALS = "Số điện thoại hoặc mật khẩu không đúng.";

export default defineComponent({
  name: "Login",
  components: {
    Loading
  },

  setup() {
    const phone = ref("");
    const password = ref("");
    const isError = ref(false);
    const errorMessage = ref("");
    const isLoading = ref(false);

    async function login() {
      if (!phone.value || !password.value) {
        setError(ERROR_EMPTY);
        return;
      }

      isLoading.value = true;

      try {
        await Auth.logIn(phone.value, password.value);
        Auth.setIsAuth(phone.value);
        router.push({ name: "Home" });
      } catch (error) {
        setError(ERROR_WRONG_CREDENTIALS);
      } finally {
        isLoading.value = false;
      }
    }

    function setError(message: string) {
      isError.value = true;
      errorMessage.value = message;
    }

    return {
      phone,
      password,
      isError,
      errorMessage,
      isLoading,
      login
    };
  }
});
